import React from 'react';
import { Helmet } from 'react-helmet-async';

export default function Profile() {
  return (
    <div className="py-20 bg-black animate-fade-in">
      <Helmet>
        <title>Profile – HEINE DESIGN</title>
        <meta name="description" content="Minimalistic Scandinavian Design. We are a Danish furniture design company who specializes in modern design. Our company has existed since 1998." />
      </Helmet>

      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="space-y-4 mb-16 text-center">
          <span className="text-xs tracking-[0.25em] uppercase text-brand-oak font-semibold block">
            Hvem er vi
          </span>
          <h1 className="text-3xl md:text-4xl font-light tracking-tight text-white uppercase">
            Profile & Design
          </h1>
          <div className="h-[1px] w-20 bg-brand-oak mx-auto" />
        </div>

        {/* Hero Image / Material Detail */}
        <div className="aspect-[21/9] w-full bg-brand-light rounded-sm overflow-hidden border border-brand-gray mb-16">
          <img
            src="https://assets.auxodev.dk/assets/f345d65a-1d50-4485-b2fa-cf1f9f3e4dca/heine-2-bench-hd1.jpg"
            alt="Heine Design Håndværk"
            className="w-full h-full object-cover opacity-90"
          />
        </div>

        {/* Bilingual Presentation */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-16 mb-20 border-b border-brand-gray pb-16">
          {/* Dansk */}
          <div className="space-y-6 md:border-r md:border-brand-gray md:pr-16">
            <h2 className="text-xs tracking-[0.25em] uppercase text-brand-oak font-semibold">
              Dansk
            </h2>
            <div className="space-y-4 text-sm text-brand-charcoal leading-relaxed font-display font-light tracking-wide">
              <h3 className="font-display text-xl font-light text-white tracking-[0.15em] uppercase leading-snug mb-6">
                Minimalistisk Skandinavisk Design
              </h3>
              <p>Vi er en dansk møbeldesignvirksomhed, der specialiserer sig i moderne design.</p>
              <p>Vores virksomhed har eksisteret siden 1998. I den tid har vi udviklet nye og innovative møbler, primært i rustfrit stål og af høj kvalitet.</p>
              <p>Alle produkter er håndlavede og udviklet i Danmark.</p>
              <p>Nu har vi etableret et stærkt fundament for vores virksomhed i Skandinavien, og vi søger nu nye kontakter i udlandet.</p>
            </div>
          </div>

          {/* English */}
          <div className="space-y-6">
            <h2 className="text-xs tracking-[0.25em] uppercase text-brand-oak font-semibold">
              English
            </h2>
            <div className="space-y-4 text-sm text-brand-charcoal leading-relaxed font-display font-light tracking-wide">
              <h3 className="font-display text-xl font-light text-white tracking-[0.15em] uppercase leading-snug mb-6">
                Minimalistic Scandinavian Design
              </h3>
              <p>We are a Danish furniture design company who specializes in modern design.</p>
              <p>Our company has existed since 1998. In that time we have developed new and innovative furniture mostly in stainless steel and high quality.</p>
              <p>All products are handmade and developed in Denmark.</p>
              <p>Now we have established a strong foundation for our company in Scandinavia and now we seek new contacts abroad.</p>
            </div>
          </div>
        </div>

        {/* Contact & Bank Details Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 text-sm">
          {/* Company Details */}
          <div className="space-y-6">
            <h3 className="text-xs tracking-[0.25em] uppercase text-[#af9e9b] font-semibold border-b border-brand-gray pb-2">
              Virksomhedsoplysninger
            </h3>
            <ul className="space-y-3 text-brand-charcoal font-light">
              <li className="flex justify-between">
                <span className="font-medium text-brand-oak">Navn:</span>
                <span>Heine Design</span>
              </li>
              <li className="flex justify-between">
                <span className="font-medium text-brand-oak">Etableret:</span>
                <span>1998</span>
              </li>
              <li className="flex justify-between">
                <span className="font-medium text-brand-oak">Adresse:</span>
                <span>Råmosevej 28, DK-2750 Ballerup, Denmark</span>
              </li>
              <li className="flex justify-between">
                <span className="font-medium text-brand-oak">Mobil:</span>
                <span>+45 22 44 35 85</span>
              </li>
              <li className="flex justify-between">
                <span className="font-medium text-brand-oak">Email:</span>
                <a href="mailto:info@heinedesign.com" className="text-white hover:text-brand-oak hover:underline">info@heinedesign.com</a>
              </li>
              <li className="flex justify-between">
                <span className="font-medium text-brand-oak">CVR. Nr.:</span>
                <span>Dk 20 43 06 99</span>
              </li>
            </ul>
          </div>

          {/* Bank Details */}
          <div className="space-y-6">
            <h3 className="text-xs tracking-[0.25em] uppercase text-[#af9e9b] font-semibold border-b border-brand-gray pb-2">
              Bankoplysninger
            </h3>
            <ul className="space-y-3 text-brand-charcoal font-light">
              <li className="flex justify-between">
                <span className="font-medium text-brand-oak">Bank:</span>
                <span>Vendsyssel Sparekasse</span>
              </li>
              <li className="flex justify-between">
                <span className="font-medium text-brand-oak">Konto:</span>
                <span>9070-1628052901</span>
              </li>
              <li className="flex justify-between">
                <span className="font-medium text-brand-oak">Swift:</span>
                <span>VRAADK21</span>
              </li>
              <li className="flex justify-between">
                <span className="font-medium text-brand-oak">Iban code:</span>
                <span>DK6590701628052901</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}
